import React, { useMemo } from 'react';
import { Form as TeaForm } from 'tea-component';
import { useField } from 'react-final-form-hooks';
import type { UseFormResultType, ItemProps, ItemInjectProps } from './types';

const Form: React.FC<UseFormResultType> = (props) => {
  const { children, form, validating, submitting, handleSubmit, ...restProps } = props;

  return (
    <form onSubmit={handleSubmit}>
      <TeaForm {...restProps}>
        {React.Children.map(children, (child) => {
          return React.isValidElement(child) ? React.cloneElement(child, { form, validating, submitting }) : null;
        })}
      </TeaForm>
    </form>
  );
};

export const Item: React.FC<ItemProps> = (props) => {
  const { name, form, validating, submitting, children, defaultValue = '', ...restProps } = props as ItemInjectProps;
  const { input, meta } = useField(name, form);

  const status = useMemo(() => {
    if (meta.active && validating) {
      return 'validating';
    }
    if (!meta.touched) {
      return undefined;
    }
    return meta.error ? 'error' : 'success';
  }, [validating, submitting, meta]);

  return (
    <TeaForm.Item
      status={status}
      align={'middle'}
      {...restProps}
      message={status === 'error' && (meta.error || restProps?.message)}
    >
      {React.Children.map(children, (child) => {
        return React.isValidElement(child)
          ? React.cloneElement(child, { ...input, value: input?.value || defaultValue })
          : null;
      })}
    </TeaForm.Item>
  );
};

export default Form;
